<template>
  <div>
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('accountBondObjManage.title') }}</div>
      </div>
      <div class="">
        <el-table :data="accountBondObjManageInfo.accountBondObjs" style="width: 100%" border stripe>
          <el-table-column prop="bobjId" :label="$t('accountBondObjManage.bobjId')" align="center" />
          <el-table-column prop="objName" :label="$t('accountBondObjManage.objName')" align="center" />
          <el-table-column prop="receivableAmount" :label="$t('accountBondObjManage.receivableAmount')"
            align="center" />
          <el-table-column prop="receivedAmount" :label="$t('accountBondObjManage.receivedAmount')" align="center" />
          <el-table-column prop="startTime" :label="$t('accountBondObjManage.startTime')" align="center" />
          <el-table-column prop="endTime" :label="$t('accountBondObjManage.endTime')" align="center" />
        </el-table>

        <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
          layout="total, prev, pager, next" :total="accountBondObjManageInfo.total" class="pagination" />
      </div>
    </el-card>
  </div>
</template>

<script>
import { queryAccountBondObj } from '@/api/goods/accountBondObjManage/accountBondObjApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AccountBondObjManage',
  data() {
    return {
      accountBondObjManageInfo: {
        accountBondObjs: [],
        total: 0,
        conditions: {
          objId: ''
        }
      },
      currentPage: 1,
      pageSize: 10
    }
  },
  created() {
    this.accountBondObjManageInfo.conditions.objId = getShopId()
    this._listAccountBondObjs(this.currentPage, this.pageSize)
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val
      this._listAccountBondObjs(this.currentPage, this.pageSize)
    },
    async _listAccountBondObjs(page, rows) {
      try {
        const params = {
          ...this.accountBondObjManageInfo.conditions,
          page,
          row: rows
        }
        const res = await queryAccountBondObj(params)
        this.accountBondObjManageInfo.accountBondObjs = res.data
        this.accountBondObjManageInfo.total = res.total
      } catch (error) {
        console.error('获取保证金对象列表失败:', error)
      }
    }
  }
}
</script>

<style scoped>
.box-card {
  margin: 20px;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>